import styled from 'styled-components';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDescriptionList from 'UIComponents/list/UIDescriptionList';
import UIFlex from 'UIComponents/layout/UIFlex';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import ViewFlowLink from 'flow-doctor-lib/components/common/ViewFlowLink';
import ObjectProfile from 'flow-doctor-lib/components/diagnosis/objects/ObjectProfile';
import EnrollmentAnalysisReasons from 'flow-doctor-lib/components/diagnosis/reasons/EnrollmentAnalysisReasons';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { TIMESTAMP_FORMAT } from 'flow-doctor-lib/constants/Global';
import ViewRecordLink from 'flow-doctor-lib/components/diagnosis/ViewRecordLink';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MaxWidthDiv = styled.div.withConfig({
  displayName: "EnrollmentDiagnosisPanelBodyHeader__MaxWidthDiv",
  componentId: "nv8ydv-0"
})(["max-width:75%;"]);
const EnrollmentDiagnosisPanelBodyHeader = ({
  diagnosisResult,
  enrollmentEvent
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(MaxWidthDiv, {
        children: /*#__PURE__*/_jsx(ObjectProfile, {
          diagnosisResult: diagnosisResult,
          enrollmentLogEvent: enrollmentEvent
        })
      }), /*#__PURE__*/_jsx(ViewRecordLink, {
        enrollmentEvent: enrollmentEvent
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "300",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.objectEnrolledInWorkflow_jsx",
        elements: {
          ObjectTypeLabel,
          ViewFlowLink
        },
        options: {
          objectTypeLabel: {
            lowerCase: true,
            portalId: enrollmentEvent.portalId,
            plural: false,
            objectTypeId: enrollmentEvent.objectTypeId
          },
          viewFlowLink: {
            portalId: enrollmentEvent.portalId,
            flowId: enrollmentEvent.flowId,
            shouldUseWorkflowName: true
          }
        }
      })
    }), /*#__PURE__*/_jsxs(UIDescriptionList, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrolledOn"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: I18n.moment.userTz(enrollmentEvent.timestamp),
          format: TIMESTAMP_FORMAT
        })
      }), /*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.label"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(EnrollmentAnalysisReasons, {
          diagnosisResult: diagnosisResult,
          selectedEnrollment: enrollmentEvent
        })
      }), getIsInternal() && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeInternalLabel"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: enrollmentEvent.enrollType
        })]
      })]
    })]
  });
};
export default EnrollmentDiagnosisPanelBodyHeader;